/**
 * name: @storyblok/js
 * (c) 2025
 * description: SDK to integrate Storyblok into your project using JavaScript.
 * author: undefined
 */
let z = !1;
const D = [],
  J = i => new Promise((e, t) => {
    if (typeof window > "u" || (window.storyblokRegisterEvent = r => {
      if (window.location === window.parent.location) {
        console.warn("You are not in Draft Mode or in the Visual Editor.");
        return;
      }
      z ? r() : D.push(r);
    }, document.getElementById("storyblok-javascript-bridge"))) return;
    const s = document.createElement("script");
    s.async = !0, s.src = i, s.id = "storyblok-javascript-bridge", s.onerror = r => t(r), s.onload = r => {
      D.forEach(o => o()), z = !0, e(r);
    }, document.getElementsByTagName("head")[0].appendChild(s);
  });
var ie = Object.defineProperty,
  oe = (i, e, t) => e in i ? ie(i, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : i[e] = t,
  m = (i, e, t) => oe(i, typeof e != "symbol" ? e + "" : e, t);
class ne extends Error {
  constructor(e) {
    super(e), this.name = "AbortError";
  }
}
function ae(i, e, t) {
  if (!Number.isFinite(e)) throw new TypeError("Expected `limit` to be a finite number");
  if (!Number.isFinite(t)) throw new TypeError("Expected `interval` to be a finite number");
  const s = [];
  let r = [],
    o = 0,
    n = !1;
  const c = async () => {
      o++;
      const h = s.shift();
      if (h) try {
        const p = await i(...h.args);
        h.resolve(p);
      } catch (p) {
        h.reject(p);
      }
      const u = setTimeout(() => {
        o--, s.length > 0 && c(), r = r.filter(p => p !== u);
      }, t);
      r.includes(u) || r.push(u);
    },
    a = (...h) => n ? Promise.reject(new Error("Throttled function is already aborted and not accepting new promises")) : new Promise((u, p) => {
      s.push({
        resolve: u,
        reject: p,
        args: h
      }), o < e && c();
    });
  return a.abort = () => {
    n = !0, r.forEach(clearTimeout), r = [], s.forEach(h => h.reject(() => new ne("Throttle function aborted"))), s.length = 0;
  }, a;
}
class C {
  constructor() {
    m(this, "isCDNUrl", (e = "") => e.includes("/cdn/")), m(this, "getOptionsPage", (e, t = 25, s = 1) => ({
      ...e,
      per_page: t,
      page: s
    })), m(this, "delay", e => new Promise(t => setTimeout(t, e))), m(this, "arrayFrom", (e = 0, t) => Array.from({
      length: e
    }, t)), m(this, "range", (e = 0, t = e) => {
      const s = Math.abs(t - e) || 0,
        r = e < t ? 1 : -1;
      return this.arrayFrom(s, (o, n) => n * r + e);
    }), m(this, "asyncMap", async (e, t) => Promise.all(e.map(t))), m(this, "flatMap", (e = [], t) => e.map(t).reduce((s, r) => [...s, ...r], [])), m(this, "escapeHTML", function (e) {
      const t = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        },
        s = /[&<>"']/g,
        r = new RegExp(s.source);
      return e && r.test(e) ? e.replace(s, o => t[o]) : e;
    });
  }
  /**
   * @method stringify
   * @param  {object} params
   * @param  {string} prefix
   * @param  {boolean} isArray
   * @return {string} Stringified object
   */
  stringify(e, t, s) {
    const r = [];
    for (const o in e) {
      if (!Object.prototype.hasOwnProperty.call(e, o)) continue;
      const n = e[o];
      if (n == null) continue;
      const c = s ? "" : encodeURIComponent(o);
      let a;
      typeof n == "object" ? a = this.stringify(n, t ? t + encodeURIComponent(`[${c}]`) : c, Array.isArray(n)) : a = `${t ? t + encodeURIComponent(`[${c}]`) : c}=${encodeURIComponent(n)}`, r.push(a);
    }
    return r.join("&");
  }
  /**
   * @method getRegionURL
   * @param  {string} regionCode region code, could be eu, us, cn, ap or ca
   * @return {string} The base URL of the region
   */
  getRegionURL(e) {
    const t = "api.storyblok.com",
      s = "api-us.storyblok.com",
      r = "app.storyblokchina.cn",
      o = "api-ap.storyblok.com",
      n = "api-ca.storyblok.com";
    switch (e) {
      case "us":
        return s;
      case "cn":
        return r;
      case "ap":
        return o;
      case "ca":
        return n;
      default:
        return t;
    }
  }
}
const le = function (i, e) {
    const t = {};
    for (const s in i) {
      const r = i[s];
      e.includes(s) && r !== null && (t[s] = r);
    }
    return t;
  },
  ce = i => i === "email",
  he = () => ({
    singleTag: "hr"
  }),
  ue = () => ({
    tag: "blockquote"
  }),
  de = () => ({
    tag: "ul"
  }),
  pe = i => ({
    tag: ["pre", {
      tag: "code",
      attrs: i.attrs
    }]
  }),
  ge = () => ({
    singleTag: "br"
  }),
  fe = i => ({
    tag: `h${i.attrs.level}`
  }),
  me = i => ({
    singleTag: [{
      tag: "img",
      attrs: le(i.attrs, ["src", "alt", "title"])
    }]
  }),
  ye = () => ({
    tag: "li"
  }),
  be = () => ({
    tag: "ol"
  }),
  ke = () => ({
    tag: "p"
  }),
  ve = i => ({
    tag: [{
      tag: "span",
      attrs: {
        "data-type": "emoji",
        "data-name": i.attrs.name,
        emoji: i.attrs.emoji
      }
    }]
  }),
  $e = () => ({
    tag: "b"
  }),
  Te = () => ({
    tag: "s"
  }),
  we = () => ({
    tag: "u"
  }),
  Re = () => ({
    tag: "strong"
  }),
  Ee = () => ({
    tag: "code"
  }),
  _e = () => ({
    tag: "i"
  }),
  Se = i => {
    if (!i.attrs) return {
      tag: ""
    };
    const e = new C().escapeHTML,
      t = {
        ...i.attrs
      },
      {
        linktype: s = "url"
      } = i.attrs;
    if (delete t.linktype, t.href && (t.href = e(i.attrs.href || "")), ce(s) && (t.href = `mailto:${t.href}`), t.anchor && (t.href = `${t.href}#${t.anchor}`, delete t.anchor), t.custom) {
      for (const r in t.custom) t[r] = t.custom[r];
      delete t.custom;
    }
    return {
      tag: [{
        tag: "a",
        attrs: t
      }]
    };
  },
  je = i => ({
    tag: [{
      tag: "span",
      attrs: i.attrs
    }]
  }),
  Ie = () => ({
    tag: "sub"
  }),
  xe = () => ({
    tag: "sup"
  }),
  Ae = i => ({
    tag: [{
      tag: "span",
      attrs: i.attrs
    }]
  }),
  Oe = i => {
    var e;
    return (e = i.attrs) != null && e.color ? {
      tag: [{
        tag: "span",
        attrs: {
          style: `background-color:${i.attrs.color};`
        }
      }]
    } : {
      tag: ""
    };
  },
  Le = i => {
    var e;
    return (e = i.attrs) != null && e.color ? {
      tag: [{
        tag: "span",
        attrs: {
          style: `color:${i.attrs.color}`
        }
      }]
    } : {
      tag: ""
    };
  },
  Ce = {
    nodes: {
      horizontal_rule: he,
      blockquote: ue,
      bullet_list: de,
      code_block: pe,
      hard_break: ge,
      heading: fe,
      image: me,
      list_item: ye,
      ordered_list: be,
      paragraph: ke,
      emoji: ve
    },
    marks: {
      bold: $e,
      strike: Te,
      underline: we,
      strong: Re,
      code: Ee,
      italic: _e,
      link: Se,
      styled: je,
      subscript: Ie,
      superscript: xe,
      anchor: Ae,
      highlight: Oe,
      textStyle: Le
    }
  },
  Pe = function (i) {
    const e = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      },
      t = /[&<>"']/g,
      s = new RegExp(t.source);
    return i && s.test(i) ? i.replace(t, r => e[r]) : i;
  };
let q = !1,
  P = class {
    constructor(e) {
      m(this, "marks"), m(this, "nodes"), e || (e = Ce), this.marks = e.marks || [], this.nodes = e.nodes || [];
    }
    addNode(e, t) {
      this.nodes[e] = t;
    }
    addMark(e, t) {
      this.marks[e] = t;
    }
    render(e, t = {
      optimizeImages: !1
    }, s = !0) {
      if (!q && s && (console.warn("Warning ⚠️: The RichTextResolver class is deprecated and will be removed in the next major release. Please use the `@storyblok/richtext` package instead. https://github.com/storyblok/richtext/"), q = !0), e && e.content && Array.isArray(e.content)) {
        let r = "";
        return e.content.forEach(o => {
          r += this.renderNode(o);
        }), t.optimizeImages ? this.optimizeImages(r, t.optimizeImages) : r;
      }
      return console.warn(`The render method must receive an Object with a "content" field.
      The "content" field must be an array of nodes as the type ISbRichtext.
      ISbRichtext:
        content?: ISbRichtext[]
        marks?: ISbRichtext[]
        attrs?: any
        text?: string
        type: string
        
        Example:
        {
          content: [
            {
              content: [
                {
                  text: 'Hello World',
                  type: 'text'
                }
              ],
              type: 'paragraph'
            }
          ],
          type: 'doc'
        }`), "";
    }
    optimizeImages(e, t) {
      let s = 0,
        r = 0,
        o = "",
        n = "";
      typeof t != "boolean" && (typeof t.width == "number" && t.width > 0 && (o += `width="${t.width}" `, s = t.width), typeof t.height == "number" && t.height > 0 && (o += `height="${t.height}" `, r = t.height), (t.loading === "lazy" || t.loading === "eager") && (o += `loading="${t.loading}" `), typeof t.class == "string" && t.class.length > 0 && (o += `class="${t.class}" `), t.filters && (typeof t.filters.blur == "number" && t.filters.blur >= 0 && t.filters.blur <= 100 && (n += `:blur(${t.filters.blur})`), typeof t.filters.brightness == "number" && t.filters.brightness >= -100 && t.filters.brightness <= 100 && (n += `:brightness(${t.filters.brightness})`), t.filters.fill && (t.filters.fill.match(/[0-9A-F]{6}/gi) || t.filters.fill === "transparent") && (n += `:fill(${t.filters.fill})`), t.filters.format && ["webp", "png", "jpeg"].includes(t.filters.format) && (n += `:format(${t.filters.format})`), typeof t.filters.grayscale == "boolean" && t.filters.grayscale && (n += ":grayscale()"), typeof t.filters.quality == "number" && t.filters.quality >= 0 && t.filters.quality <= 100 && (n += `:quality(${t.filters.quality})`), t.filters.rotate && [90, 180, 270].includes(t.filters.rotate) && (n += `:rotate(${t.filters.rotate})`), n.length > 0 && (n = `/filters${n}`))), o.length > 0 && (e = e.replace(/<img/g, `<img ${o.trim()}`));
      const c = s > 0 || r > 0 || n.length > 0 ? `${s}x${r}${n}` : "";
      return e = e.replace(/a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|bmp)/g, `a.storyblok.com/f/$1/$2.$3/m/${c}`), typeof t != "boolean" && (t.sizes || t.srcset) && (e = e.replace(/<img.*?src=["|'](.*?)["|']/g, a => {
        var h, u;
        const p = a.match(/a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|bmp)/g);
        if (p && p.length > 0) {
          const b = {
            srcset: (h = t.srcset) == null ? void 0 : h.map(y => {
              if (typeof y == "number") return `//${p}/m/${y}x0${n} ${y}w`;
              if (typeof y == "object" && y.length === 2) {
                let S = 0,
                  x = 0;
                return typeof y[0] == "number" && (S = y[0]), typeof y[1] == "number" && (x = y[1]), `//${p}/m/${S}x${x}${n} ${S}w`;
              }
              return "";
            }).join(", "),
            sizes: (u = t.sizes) == null ? void 0 : u.map(y => y).join(", ")
          };
          let _ = "";
          return b.srcset && (_ += `srcset="${b.srcset}" `), b.sizes && (_ += `sizes="${b.sizes}" `), a.replace(/<img/g, `<img ${_.trim()}`);
        }
        return a;
      })), e;
    }
    renderNode(e) {
      const t = [];
      e.marks && e.marks.forEach(r => {
        const o = this.getMatchingMark(r);
        o && o.tag !== "" && t.push(this.renderOpeningTag(o.tag));
      });
      const s = this.getMatchingNode(e);
      return s && s.tag && t.push(this.renderOpeningTag(s.tag)), e.content ? e.content.forEach(r => {
        t.push(this.renderNode(r));
      }) : e.text ? t.push(Pe(e.text)) : s && s.singleTag ? t.push(this.renderTag(s.singleTag, " /")) : s && s.html ? t.push(s.html) : e.type === "emoji" && t.push(this.renderEmoji(e)), s && s.tag && t.push(this.renderClosingTag(s.tag)), e.marks && e.marks.slice(0).reverse().forEach(r => {
        const o = this.getMatchingMark(r);
        o && o.tag !== "" && t.push(this.renderClosingTag(o.tag));
      }), t.join("");
    }
    renderTag(e, t) {
      return e.constructor === String ? `<${e}${t}>` : e.map(s => {
        if (s.constructor === String) return `<${s}${t}>`;
        {
          let r = `<${s.tag}`;
          if (s.attrs) {
            for (const o in s.attrs) if (Object.prototype.hasOwnProperty.call(s.attrs, o)) {
              const n = s.attrs[o];
              n !== null && (r += ` ${o}="${n}"`);
            }
          }
          return `${r}${t}>`;
        }
      }).join("");
    }
    renderOpeningTag(e) {
      return this.renderTag(e, "");
    }
    renderClosingTag(e) {
      return e.constructor === String ? `</${e}>` : e.slice(0).reverse().map(t => t.constructor === String ? `</${t}>` : `</${t.tag}>`).join("");
    }
    getMatchingNode(e) {
      const t = this.nodes[e.type];
      if (typeof t == "function") return t(e);
    }
    getMatchingMark(e) {
      const t = this.marks[e.type];
      if (typeof t == "function") return t(e);
    }
    renderEmoji(e) {
      if (e.attrs.emoji) return e.attrs.emoji;
      const t = [{
        tag: "img",
        attrs: {
          src: e.attrs.fallbackImage,
          draggable: "false",
          loading: "lazy",
          align: "absmiddle"
        }
      }];
      return this.renderTag(t, " /");
    }
  };
class Ne {
  constructor(e) {
    m(this, "baseURL"), m(this, "timeout"), m(this, "headers"), m(this, "responseInterceptor"), m(this, "fetch"), m(this, "ejectInterceptor"), m(this, "url"), m(this, "parameters"), m(this, "fetchOptions"), this.baseURL = e.baseURL, this.headers = e.headers || new Headers(), this.timeout = e != null && e.timeout ? e.timeout * 1e3 : 0, this.responseInterceptor = e.responseInterceptor, this.fetch = (...t) => e.fetch ? e.fetch(...t) : fetch(...t), this.ejectInterceptor = !1, this.url = "", this.parameters = {}, this.fetchOptions = {};
  }
  /**
   *
   * @param url string
   * @param params ISbStoriesParams
   * @returns Promise<ISbResponse | Error>
   */
  get(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("get");
  }
  post(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("post");
  }
  put(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("put");
  }
  delete(e, t) {
    return this.url = e, this.parameters = t ?? {}, this._methodHandler("delete");
  }
  async _responseHandler(e) {
    const t = [],
      s = {
        data: {},
        headers: {},
        status: 0,
        statusText: ""
      };
    e.status !== 204 && (await e.json().then(r => {
      s.data = r;
    }));
    for (const r of e.headers.entries()) t[r[0]] = r[1];
    return s.headers = {
      ...t
    }, s.status = e.status, s.statusText = e.statusText, s;
  }
  async _methodHandler(e) {
    let t = `${this.baseURL}${this.url}`,
      s = null;
    if (e === "get") {
      const a = new C();
      t = `${this.baseURL}${this.url}?${a.stringify(this.parameters)}`;
    } else s = JSON.stringify(this.parameters);
    const r = new URL(t),
      o = new AbortController(),
      {
        signal: n
      } = o;
    let c;
    this.timeout && (c = setTimeout(() => o.abort(), this.timeout));
    try {
      const a = await this.fetch(`${r}`, {
        method: e,
        headers: this.headers,
        body: s,
        signal: n,
        ...this.fetchOptions
      });
      this.timeout && clearTimeout(c);
      const h = await this._responseHandler(a);
      return this.responseInterceptor && !this.ejectInterceptor ? this._statusHandler(this.responseInterceptor(h)) : this._statusHandler(h);
    } catch (a) {
      return {
        message: a
      };
    }
  }
  setFetchOptions(e = {}) {
    Object.keys(e).length > 0 && "method" in e && delete e.method, this.fetchOptions = {
      ...e
    };
  }
  eject() {
    this.ejectInterceptor = !0;
  }
  _statusHandler(e) {
    const t = /20[0-6]/g;
    return new Promise((s, r) => {
      if (t.test(`${e.status}`)) return s(e);
      const o = {
        message: e.statusText,
        status: e.status,
        response: Array.isArray(e.data) ? e.data[0] : e.data.error || e.data.slug
      };
      r(o);
    });
  }
}
const F = "SB-Agent",
  H = {
    defaultAgentName: "SB-JS-CLIENT",
    defaultAgentVersion: "SB-Agent-Version",
    packageVersion: "6.0.0"
  };
let O = {};
const j = {};
class He {
  /**
   *
   * @param config ISbConfig interface
   * @param pEndpoint string, optional
   */
  constructor(e, t) {
    m(this, "client"), m(this, "maxRetries"), m(this, "retriesDelay"), m(this, "throttle"), m(this, "accessToken"), m(this, "cache"), m(this, "helpers"), m(this, "resolveCounter"), m(this, "relations"), m(this, "links"), m(this, "richTextResolver"), m(this, "resolveNestedRelations"), m(this, "stringifiedStoriesCache");
    let s = e.endpoint || t;
    if (!s) {
      const n = new C().getRegionURL,
        c = e.https === !1 ? "http" : "https";
      e.oauthToken ? s = `${c}://${n(e.region)}/v1` : s = `${c}://${n(e.region)}/v2`;
    }
    const r = new Headers();
    r.set("Content-Type", "application/json"), r.set("Accept", "application/json"), e.headers && (e.headers.constructor.name === "Headers" ? e.headers.entries().toArray() : Object.entries(e.headers)).forEach(([n, c]) => {
      r.set(n, c);
    }), r.has(F) || (r.set(F, H.defaultAgentName), r.set(H.defaultAgentVersion, H.packageVersion));
    let o = 5;
    e.oauthToken && (r.set("Authorization", e.oauthToken), o = 3), e.rateLimit && (o = e.rateLimit), e.richTextSchema ? this.richTextResolver = new P(e.richTextSchema) : this.richTextResolver = new P(), e.componentResolver && this.setComponentResolver(e.componentResolver), this.maxRetries = e.maxRetries || 10, this.retriesDelay = 300, this.throttle = ae(this.throttledRequest.bind(this), o, 1e3), this.accessToken = e.accessToken || "", this.relations = {}, this.links = {}, this.cache = e.cache || {
      clear: "manual"
    }, this.helpers = new C(), this.resolveCounter = 0, this.resolveNestedRelations = e.resolveNestedRelations || !0, this.stringifiedStoriesCache = {}, this.client = new Ne({
      baseURL: s,
      timeout: e.timeout || 0,
      headers: r,
      responseInterceptor: e.responseInterceptor,
      fetch: e.fetch
    });
  }
  setComponentResolver(e) {
    this.richTextResolver.addNode("blok", t => {
      let s = "";
      return t.attrs.body && t.attrs.body.forEach(r => {
        s += e(r.component, r);
      }), {
        html: s
      };
    });
  }
  parseParams(e) {
    return e.token || (e.token = this.getToken()), e.cv || (e.cv = j[e.token]), Array.isArray(e.resolve_relations) && (e.resolve_relations = e.resolve_relations.join(",")), typeof e.resolve_relations < "u" && (e.resolve_level = 2), e;
  }
  factoryParamOptions(e, t) {
    return this.helpers.isCDNUrl(e) ? this.parseParams(t) : t;
  }
  makeRequest(e, t, s, r, o) {
    const n = this.factoryParamOptions(e, this.helpers.getOptionsPage(t, s, r));
    return this.cacheResponse(e, n, void 0, o);
  }
  get(e, t, s) {
    t || (t = {});
    const r = `/${e}`,
      o = this.factoryParamOptions(r, t);
    return this.cacheResponse(r, o, void 0, s);
  }
  async getAll(e, t, s, r) {
    const o = (t == null ? void 0 : t.per_page) || 25,
      n = `/${e}`.replace(/\/$/, ""),
      c = s ?? n.substring(n.lastIndexOf("/") + 1),
      a = 1,
      h = await this.makeRequest(n, t, o, a, r),
      u = h.total ? Math.ceil(h.total / o) : 1,
      p = await this.helpers.asyncMap(this.helpers.range(a, u), b => this.makeRequest(n, t, o, b + 1, r));
    return this.helpers.flatMap([h, ...p], b => Object.values(b.data[c]));
  }
  post(e, t, s) {
    const r = `/${e}`;
    return Promise.resolve(this.throttle("post", r, t, s));
  }
  put(e, t, s) {
    const r = `/${e}`;
    return Promise.resolve(this.throttle("put", r, t, s));
  }
  delete(e, t, s) {
    t || (t = {});
    const r = `/${e}`;
    return Promise.resolve(this.throttle("delete", r, t, s));
  }
  getStories(e, t) {
    return this._addResolveLevel(e), this.get("cdn/stories", e, t);
  }
  getStory(e, t, s) {
    return this._addResolveLevel(t), this.get(`cdn/stories/${e}`, t, s);
  }
  getToken() {
    return this.accessToken;
  }
  ejectInterceptor() {
    this.client.eject();
  }
  _addResolveLevel(e) {
    typeof e.resolve_relations < "u" && (e.resolve_level = 2);
  }
  _cleanCopy(e) {
    return JSON.parse(JSON.stringify(e));
  }
  _insertLinks(e, t, s) {
    const r = e[t];
    r && r.fieldtype === "multilink" && r.linktype === "story" && typeof r.id == "string" && this.links[s][r.id] ? r.story = this._cleanCopy(this.links[s][r.id]) : r && r.linktype === "story" && typeof r.uuid == "string" && this.links[s][r.uuid] && (r.story = this._cleanCopy(this.links[s][r.uuid]));
  }
  /**
   *
   * @param resolveId A counter number as a string
   * @param uuid The uuid of the story
   * @returns string | object
   */
  getStoryReference(e, t) {
    return this.relations[e][t] ? JSON.parse(this.stringifiedStoriesCache[t] || JSON.stringify(this.relations[e][t])) : t;
  }
  /**
   * Resolves a field's value by replacing UUIDs with their corresponding story references
   * @param jtree - The JSON tree object containing the field to resolve
   * @param treeItem - The key of the field to resolve
   * @param resolveId - The unique identifier for the current resolution context
   *
   * This method handles both single string UUIDs and arrays of UUIDs:
   * - For single strings: directly replaces the UUID with the story reference
   * - For arrays: maps through each UUID and replaces with corresponding story references
   */
  _resolveField(e, t, s) {
    const r = e[t];
    typeof r == "string" ? e[t] = this.getStoryReference(s, r) : Array.isArray(r) && (e[t] = r.map(o => this.getStoryReference(s, o)).filter(Boolean));
  }
  /**
   * Inserts relations into the JSON tree by resolving references
   * @param jtree - The JSON tree object to process
   * @param treeItem - The current field being processed
   * @param fields - The relation patterns to resolve (string or array of strings)
   * @param resolveId - The unique identifier for the current resolution context
   *
   * This method handles two types of relation patterns:
   * 1. Nested relations: matches fields that end with the current field name
   *    Example: If treeItem is "event_type", it matches patterns like "*.event_type"
   *
   * 2. Direct component relations: matches exact component.field patterns
   *    Example: "event.event_type" for component "event" and field "event_type"
   *
   * The method supports both string and array formats for the fields parameter,
   * allowing flexible specification of relation patterns.
   */
  _insertRelations(e, t, s, r) {
    if (Array.isArray(s) ? s.find(n => n.endsWith(`.${t}`)) : s.endsWith(`.${t}`)) {
      this._resolveField(e, t, r);
      return;
    }
    const o = e.component ? `${e.component}.${t}` : t;
    (Array.isArray(s) ? s.includes(o) : s === o) && this._resolveField(e, t, r);
  }
  /**
   * Recursively traverses and resolves relations in the story content tree
   * @param story - The story object containing the content to process
   * @param fields - The relation patterns to resolve
   * @param resolveId - The unique identifier for the current resolution context
   */
  iterateTree(e, t, s) {
    const r = (o, n = "") => {
      if (!(!o || o._stopResolving)) {
        if (Array.isArray(o)) o.forEach((c, a) => r(c, `${n}[${a}]`));else if (typeof o == "object") for (const c in o) {
          const a = n ? `${n}.${c}` : c;
          (o.component && o._uid || o.type === "link") && (this._insertRelations(o, c, t, s), this._insertLinks(o, c, s)), r(o[c], a);
        }
      }
    };
    r(e.content);
  }
  async resolveLinks(e, t, s) {
    let r = [];
    if (e.link_uuids) {
      const o = e.link_uuids.length,
        n = [],
        c = 50;
      for (let a = 0; a < o; a += c) {
        const h = Math.min(o, a + c);
        n.push(e.link_uuids.slice(a, h));
      }
      for (let a = 0; a < n.length; a++) (await this.getStories({
        per_page: c,
        language: t.language,
        version: t.version,
        starts_with: t.starts_with,
        by_uuids: n[a].join(",")
      })).data.stories.forEach(h => {
        r.push(h);
      });
    } else r = e.links;
    r.forEach(o => {
      this.links[s][o.uuid] = {
        ...o,
        _stopResolving: !0
      };
    });
  }
  async resolveRelations(e, t, s) {
    let r = [];
    if (e.rel_uuids) {
      const o = e.rel_uuids.length,
        n = [],
        c = 50;
      for (let a = 0; a < o; a += c) {
        const h = Math.min(o, a + c);
        n.push(e.rel_uuids.slice(a, h));
      }
      for (let a = 0; a < n.length; a++) (await this.getStories({
        per_page: c,
        language: t.language,
        version: t.version,
        starts_with: t.starts_with,
        by_uuids: n[a].join(","),
        excluding_fields: t.excluding_fields
      })).data.stories.forEach(h => {
        r.push(h);
      });
    } else r = e.rels;
    r && r.length > 0 && r.forEach(o => {
      this.relations[s][o.uuid] = {
        ...o,
        _stopResolving: !0
      };
    });
  }
  /**
   *
   * @param responseData
   * @param params
   * @param resolveId
   * @description Resolves the relations and links of the stories
   * @returns Promise<void>
   *
   */
  async resolveStories(e, t, s) {
    var r, o;
    let n = [];
    if (this.links[s] = {}, this.relations[s] = {}, typeof t.resolve_relations < "u" && t.resolve_relations.length > 0 && (typeof t.resolve_relations == "string" && (n = t.resolve_relations.split(",")), await this.resolveRelations(e, t, s)), t.resolve_links && ["1", "story", "url", "link"].includes(t.resolve_links) && ((r = e.links) != null && r.length || (o = e.link_uuids) != null && o.length) && (await this.resolveLinks(e, t, s)), this.resolveNestedRelations) for (const c in this.relations[s]) this.iterateTree(this.relations[s][c], n, s);
    e.story ? this.iterateTree(e.story, n, s) : e.stories.forEach(c => {
      this.iterateTree(c, n, s);
    }), this.stringifiedStoriesCache = {}, delete this.links[s], delete this.relations[s];
  }
  async cacheResponse(e, t, s, r) {
    const o = this.helpers.stringify({
        url: e,
        params: t
      }),
      n = this.cacheProvider();
    if (t.version === "published" && e !== "/cdn/spaces/me") {
      const c = await n.get(o);
      if (c) return Promise.resolve(c);
    }
    return new Promise(async (c, a) => {
      var h;
      try {
        const u = await this.throttle("get", e, t, r);
        if (u.status !== 200) return a(u);
        let p = {
          data: u.data,
          headers: u.headers
        };
        if ((h = u.headers) != null && h["per-page"] && (p = Object.assign({}, p, {
          perPage: u.headers["per-page"] ? Number.parseInt(u.headers["per-page"]) : 0,
          total: u.headers["per-page"] ? Number.parseInt(u.headers.total) : 0
        })), p.data.story || p.data.stories) {
          const _ = this.resolveCounter = ++this.resolveCounter % 1e3;
          await this.resolveStories(p.data, t, `${_}`);
        }
        t.version === "published" && e !== "/cdn/spaces/me" && (await n.set(o, p));
        const b = this.cache.clear === "onpreview" && t.version === "draft" || this.cache.clear === "auto";
        return t.token && p.data.cv && (b && j[t.token] && j[t.token] !== p.data.cv && (await this.flushCache()), j[t.token] = p.data.cv), c(p);
      } catch (u) {
        if (u.response && u.status === 429 && (s = typeof s > "u" ? 0 : s + 1, s < this.maxRetries)) return console.log(`Hit rate limit. Retrying in ${this.retriesDelay / 1e3} seconds.`), await this.helpers.delay(this.retriesDelay), this.cacheResponse(e, t, s).then(c).catch(a);
        a(u);
      }
    });
  }
  throttledRequest(e, t, s, r) {
    return this.client.setFetchOptions(r), this.client[e](t, s);
  }
  cacheVersions() {
    return j;
  }
  cacheVersion() {
    return j[this.accessToken];
  }
  setCacheVersion(e) {
    this.accessToken && (j[this.accessToken] = e);
  }
  clearCacheVersion() {
    this.accessToken && (j[this.accessToken] = 0);
  }
  cacheProvider() {
    switch (this.cache.type) {
      case "memory":
        return {
          get(e) {
            return Promise.resolve(O[e]);
          },
          getAll() {
            return Promise.resolve(O);
          },
          set(e, t) {
            return O[e] = t, Promise.resolve(void 0);
          },
          flush() {
            return O = {}, Promise.resolve(void 0);
          }
        };
      case "custom":
        if (this.cache.custom) return this.cache.custom;
      // eslint-disable-next-line no-fallthrough
      default:
        return {
          get() {
            return Promise.resolve();
          },
          getAll() {
            return Promise.resolve(void 0);
          },
          set() {
            return Promise.resolve(void 0);
          },
          flush() {
            return Promise.resolve(void 0);
          }
        };
    }
  }
  async flushCache() {
    return await this.cacheProvider().flush(), this.clearCacheVersion(), this;
  }
}
const Ge = (i = {}) => {
    const {
      apiOptions: e
    } = i;
    if (!e || !e.accessToken) {
      console.error("You need to provide an access token to interact with Storyblok API. Read https://www.storyblok.com/docs/api/content-delivery#topics/authentication");
      return;
    }
    return {
      storyblokApi: new He(e)
    };
  },
  Je = i => {
    if (typeof i != "object" || typeof i._editable > "u") return {};
    try {
      const e = JSON.parse(i._editable.replace(/^<!--#storyblok#/, "").replace(/-->$/, ""));
      return e ? {
        "data-blok-c": JSON.stringify(e),
        "data-blok-uid": `${e.id}-${e.uid}`
      } : {};
    } catch {
      return {};
    }
  };
function Me(i, e) {
  if (!e) return {
    src: i,
    attrs: {}
  };
  let t = 0,
    s = 0;
  const r = {},
    o = [];
  function n(a, h, u, p, b) {
    typeof a != "number" || a <= h || a >= u ? console.warn(`[StoryblokRichText] - ${p.charAt(0).toUpperCase() + p.slice(1)} value must be a number between ${h} and ${u} (inclusive)`) : b.push(`${p}(${a})`);
  }
  if (typeof e == "object") {
    if (typeof e.width == "number" && e.width > 0 ? (r.width = e.width, t = e.width) : console.warn("[StoryblokRichText] - Width value must be a number greater than 0"), e.height && typeof e.height == "number" && e.height > 0 ? (r.height = e.height, s = e.height) : console.warn("[StoryblokRichText] - Height value must be a number greater than 0"), e.loading && ["lazy", "eager"].includes(e.loading) && (r.loading = e.loading), e.class && (r.class = e.class), e.filters) {
      const {
          filters: a
        } = e || {},
        {
          blur: h,
          brightness: u,
          fill: p,
          format: b,
          grayscale: _,
          quality: y,
          rotate: S
        } = a || {};
      h && n(h, 0, 100, "blur", o), y && n(y, 0, 100, "quality", o), u && n(u, 0, 100, "brightness", o), p && o.push(`fill(${p})`), _ && o.push("grayscale()"), S && [0, 90, 180, 270].includes(e.filters.rotate || 0) && o.push(`rotate(${S})`), b && ["webp", "png", "jpeg"].includes(b) && o.push(`format(${b})`);
    }
    e.srcset && (r.srcset = e.srcset.map(a => {
      if (typeof a == "number") return `${i}/m/${a}x0/${o.length > 0 ? `filters:${o.join(":")}` : ""} ${a}w`;
      if (Array.isArray(a) && a.length === 2) {
        const [h, u] = a;
        return `${i}/m/${h}x${u}/${o.length > 0 ? `filters:${o.join(":")}` : ""} ${h}w`;
      } else {
        console.warn("[StoryblokRichText] - srcset entry must be a number or a tuple of two numbers");
        return;
      }
    }).join(", ")), e.sizes && (r.sizes = e.sizes.join(", "));
  }
  let c = `${i}/m/`;
  return t > 0 && s > 0 && (c = `${c}${t}x${s}/`), o.length > 0 && (c = `${c}filters:${o.join(":")}`), {
    src: c,
    attrs: r
  };
}
var $ = /* @__PURE__ */(i => (i.DOCUMENT = "doc", i.HEADING = "heading", i.PARAGRAPH = "paragraph", i.QUOTE = "blockquote", i.OL_LIST = "ordered_list", i.UL_LIST = "bullet_list", i.LIST_ITEM = "list_item", i.CODE_BLOCK = "code_block", i.HR = "horizontal_rule", i.BR = "hard_break", i.IMAGE = "image", i.EMOJI = "emoji", i.COMPONENT = "blok", i.TABLE = "table", i.TABLE_ROW = "tableRow", i.TABLE_CELL = "tableCell", i.TABLE_HEADER = "tableHeader", i))($ || {}),
  E = /* @__PURE__ */(i => (i.BOLD = "bold", i.STRONG = "strong", i.STRIKE = "strike", i.UNDERLINE = "underline", i.ITALIC = "italic", i.CODE = "code", i.LINK = "link", i.ANCHOR = "anchor", i.STYLED = "styled", i.SUPERSCRIPT = "superscript", i.SUBSCRIPT = "subscript", i.TEXT_STYLE = "textStyle", i.HIGHLIGHT = "highlight", i))(E || {}),
  V = /* @__PURE__ */(i => (i.TEXT = "text", i))(V || {}),
  I = /* @__PURE__ */(i => (i.URL = "url", i.STORY = "story", i.ASSET = "asset", i.EMAIL = "email", i))(I || {});
const Be = ["area", "base", "br", "col", "embed", "hr", "img", "input", "link", "meta", "param", "source", "track", "wbr"],
  Ue = (i = {}) => Object.keys(i).map(e => `${e}="${i[e]}"`).join(" "),
  ze = (i = {}) => Object.keys(i).map(e => `${e}: ${i[e]}`).join("; ");
function De(i) {
  return i.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
const L = i => Object.fromEntries(Object.entries(i).filter(([e, t]) => t !== void 0));
function G(i, e = {}, t) {
  const s = Ue(e),
    r = s ? `${i} ${s}` : i,
    o = Array.isArray(t) ? t.join("") : t || "";
  if (i) {
    if (Be.includes(i)) return `<${r}>`;
  } else return o;
  return `<${r}>${o}</${i}>`;
}
function Ve(i = {}) {
  const e = /* @__PURE__ */new Map(),
    {
      renderFn: t = G,
      textFn: s = De,
      resolvers: r = {},
      optimizeImages: o = !1,
      keyedResolvers: n = !1
    } = i,
    c = t !== G,
    a = () => ({
      render: (l, d = {}, g) => {
        if (n && l) {
          const f = e.get(l) || 0;
          e.set(l, f + 1), d.key = `${l}-${f}`;
        }
        return t(l, d, g);
      }
    }),
    h = l => (d, g) => {
      const f = d.attrs || {};
      return g.render(l, f, d.children || null);
    },
    u = (l, d) => {
      const {
        src: g,
        alt: f,
        title: k,
        srcset: w,
        sizes: v
      } = l.attrs || {};
      let T = g,
        R = {};
      if (o) {
        const {
          src: se,
          attrs: re
        } = Me(g, o);
        T = se, R = re;
      }
      const te = {
        src: T,
        alt: f,
        title: k,
        srcset: w,
        sizes: v,
        ...R
      };
      return d.render("img", L(te));
    },
    p = (l, d) => {
      const {
        level: g,
        ...f
      } = l.attrs || {};
      return d.render(`h${g}`, f, l.children);
    },
    b = (l, d) => {
      var g, f, k, w;
      const v = d.render("img", {
        src: (g = l.attrs) == null ? void 0 : g.fallbackImage,
        alt: (f = l.attrs) == null ? void 0 : f.alt,
        style: "width: 1.25em; height: 1.25em; vertical-align: text-top",
        draggable: "false",
        loading: "lazy"
      });
      return d.render("span", {
        "data-type": "emoji",
        "data-name": (k = l.attrs) == null ? void 0 : k.name,
        "data-emoji": (w = l.attrs) == null ? void 0 : w.emoji
      }, v);
    },
    _ = (l, d) => d.render("pre", l.attrs || {}, d.render("code", {}, l.children || "")),
    y = (l, d = !1) => ({
      text: g,
      attrs: f
    }, k) => {
      const {
          class: w,
          id: v,
          ...T
        } = f || {},
        R = d ? {
          class: w,
          id: v,
          style: ze(T) || void 0
        } : f || {};
      return k.render(l, L(R), g);
    },
    S = l => N(l),
    x = l => {
      const {
        marks: d,
        ...g
      } = l;
      if ("text" in l) {
        if (d) return d.reduce((k, w) => S({
          ...w,
          text: k
        }), S({
          ...g,
          children: g.children
        }));
        const f = l.attrs || {};
        if (n) {
          const k = e.get("txt") || 0;
          e.set("txt", k + 1), f.key = `txt-${k}`;
        }
        return s(g.text, f);
      }
      return "";
    },
    U = (l, d) => {
      const {
        linktype: g,
        href: f,
        anchor: k,
        ...w
      } = l.attrs || {};
      let v = "";
      switch (g) {
        case I.ASSET:
        case I.URL:
          v = f;
          break;
        case I.EMAIL:
          v = `mailto:${f}`;
          break;
        case I.STORY:
          v = f, k && (v = `${v}#${k}`);
          break;
        default:
          v = f;
          break;
      }
      const T = {
        ...w
      };
      return v && (T.href = v), d.render("a", T, l.text);
    },
    Y = (l, d) => {
      var g, f;
      return console.warn("[StoryblokRichtText] - BLOK resolver is not available for vanilla usage"), d.render("span", {
        blok: (g = l == null ? void 0 : l.attrs) == null ? void 0 : g.body[0],
        id: (f = l.attrs) == null ? void 0 : f.id,
        style: "display: none"
      });
    },
    W = (l, d) => {
      const g = {},
        f = d.render("tbody", {}, l.children);
      return d.render("table", g, f);
    },
    X = (l, d) => {
      const g = {};
      return d.render("tr", g, l.children);
    },
    Q = (l, d) => {
      const {
          colspan: g,
          rowspan: f,
          colwidth: k,
          backgroundColor: w,
          ...v
        } = l.attrs || {},
        T = {
          ...v
        };
      g > 1 && (T.colspan = g), f > 1 && (T.rowspan = f);
      const R = [];
      return k && R.push(`width: ${k}px;`), w && R.push(`background-color: ${w};`), R.length > 0 && (T.style = R.join(" ")), d.render("td", L(T), l.children);
    },
    Z = (l, d) => {
      const {
          colspan: g,
          rowspan: f,
          colwidth: k,
          backgroundColor: w,
          ...v
        } = l.attrs || {},
        T = {
          ...v
        };
      g > 1 && (T.colspan = g), f > 1 && (T.rowspan = f);
      const R = [];
      return k && R.push(`width: ${k}px;`), w && R.push(`background-color: ${w};`), R.length > 0 && (T.style = R.join(" ")), d.render("th", L(T), l.children);
    },
    ee = new Map([[$.DOCUMENT, h("")], [$.HEADING, p], [$.PARAGRAPH, h("p")], [$.UL_LIST, h("ul")], [$.OL_LIST, h("ol")], [$.LIST_ITEM, h("li")], [$.IMAGE, u], [$.EMOJI, b], [$.CODE_BLOCK, _], [$.HR, h("hr")], [$.BR, h("br")], [$.QUOTE, h("blockquote")], [$.COMPONENT, Y], [V.TEXT, x], [E.LINK, U], [E.ANCHOR, U], [E.STYLED, y("span", !0)], [E.BOLD, y("strong")], [E.TEXT_STYLE, y("span", !0)], [E.ITALIC, y("em")], [E.UNDERLINE, y("u")], [E.STRIKE, y("s")], [E.CODE, y("code")], [E.SUPERSCRIPT, y("sup")], [E.SUBSCRIPT, y("sub")], [E.HIGHLIGHT, y("mark")], [$.TABLE, W], [$.TABLE_ROW, X], [$.TABLE_CELL, Q], [$.TABLE_HEADER, Z], ...Object.entries(r).map(([l, d]) => [l, d])]);
  function A(l) {
    const d = ee.get(l.type);
    if (!d) return console.error("<Storyblok>", `No resolver found for node type ${l.type}`), "";
    const g = a();
    if (l.type === "text") return d(l, g);
    const f = l.content ? l.content.map(N) : void 0;
    return d({
      ...l,
      children: f
    }, g);
  }
  function N(l) {
    return l.type === "doc" ? c ? l.content.map(A) : l.content.map(A).join("") : Array.isArray(l) ? l.map(A) : A(l);
  }
  return {
    render: N
  };
}
let M,
  B = "https://app.storyblok.com/f/storyblok-v2-latest.js";
const Ke = (i, e, t = {}) => {
    var c;
    const r = !(typeof window > "u") && typeof window.storyblokRegisterEvent < "u",
      o = new URL((c = window.location) == null ? void 0 : c.href).searchParams.get("_storyblok"),
      n = o !== null && +o === i;
    if (!(!r || !n)) {
      if (!i) {
        console.warn("Story ID is not defined. Please provide a valid ID.");
        return;
      }
      window.storyblokRegisterEvent(() => {
        new window.StoryblokBridge(t).on(["input", "published", "change"], h => {
          var u;
          h && (h.action === "input" && ((u = h.story) == null ? void 0 : u.id) === i ? e(h.story) : (h.action === "change" || h.action === "published") && h.storyId === i && window.location.reload());
        });
      });
    }
  },
  K = (i, e) => {
    i.addNode("blok", t => {
      let s = "";
      return t.attrs.body.forEach(r => {
        s += e(r.component, r);
      }), {
        html: s
      };
    });
  },
  Ye = (i = {}) => {
    var p, b;
    const {
      bridge: e,
      accessToken: t,
      use: s = [],
      apiOptions: r = {},
      richText: o = {},
      bridgeUrl: n
    } = i;
    r.accessToken = r.accessToken || t;
    const c = {
      bridge: e,
      apiOptions: r
    };
    let a = {};
    s.forEach(_ => {
      a = {
        ...a,
        ..._(c)
      };
    }), n && (B = n);
    const u = !(typeof window > "u") && ((b = (p = window.location) == null ? void 0 : p.search) == null ? void 0 : b.includes("_storyblok_tk"));
    return e !== !1 && u && J(B), M = new P(o.schema), o.resolver && K(M, o.resolver), a;
  },
  qe = i => {
    var e;
    return !i || !((e = i == null ? void 0 : i.content) != null && e.some(t => t.content || t.type === "blok" || t.type === "horizontal_rule"));
  },
  We = (i, e, t) => {
    let s = t || M;
    if (!s) {
      console.error("Please initialize the Storyblok SDK before calling the renderRichText function");
      return;
    }
    return qe(i) ? "" : (e && (s = new P(e.schema), e.resolver && K(s, e.resolver)), s.render(i, {}, !1));
  },
  Xe = () => J(B);
export { $ as BlockTypes, E as MarkTypes, P as RichTextResolver, Ce as RichTextSchema, V as TextTypes, Ge as apiPlugin, qe as isRichTextEmpty, Xe as loadStoryblokBridge, Ke as registerStoryblokBridge, We as renderRichText, Ve as richTextResolver, Je as storyblokEditable, Ye as storyblokInit, Ke as useStoryblokBridge };